import clsx from 'clsx';

import styles from './Avatar.module.css';
import { AvatarProps } from './types';

const Avatar = ({ id, fullName = '' }: AvatarProps) => {
  const abbreviation = fullName
    .split(' ')
    .map((initials) => initials.charAt(0))
    .join('');

  return (
    <div id={id} className={clsx(styles.avatar, `${fullName === '' ? styles.guest : styles.logged}`)}>
      {fullName !== '' && <div className={styles.abbrevation}>{abbreviation}</div>}
    </div>
  );
};

export default Avatar;
